jQuery( document ).ready( function( $ ) {
    
    $( document ).on( 'click', '.team-modal-trigger', function( e ) {
        e.preventDefault();
        let $member_card = $( this ).closest( '.team-member-card' );
        let name    = $member_card.find( '.team-member-card-name' ).html();
            name    = name.split( ' ' );
        let first   = name.shift();
            name    = first + ' ' + '<span class="highlight highlight-animation-trigger">' + name.join( ' ' ) + '</span>';
        let bio     = $member_card.find( '.team-member-full-bio' ).html();
        let content = '<div class="modal-bio"><h2 class="section-title">' + name + '</h2>' + bio + '</div>';
        let image   = '<div class="modal-image">' + $member_card.find( '.team-member-card-image' ).html() + '</div>';
        $( '#s-modal-team .modal-body' ).html( image + content );
    });

    $( document ).on( 'click', '#s-modal-team .close', function( e ) {
        e.preventDefault();
        bootstrap.Modal.getOrCreateInstance( document.getElementById( 's-modal-team' ) ).hide();
    });

});